import { jsx, Fragment } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { deprecate, fallback, isDefined, dataAttribute } from "@contember/utilities";
import { memo, forwardRef, useMemo } from "react";
const Stack = memo(forwardRef(({
  align,
  basis,
  evenly,
  children,
  className: classNameProp,
  componentClassName = "stack",
  direction,
  gap = "gutter",
  grow,
  horizontal,
  justify,
  reverse,
  shrink,
  style: styleProp,
  wrap,
  ...rest
}, ref) => {
  deprecate("1.3.0", gap === "none", '`gap="none"`', "`gap={false}`");
  gap = fallback(gap, gap === "none", false);
  deprecate("1.3.0", gap === "small", '`gap="small"`', '`gap="gap"`');
  gap = fallback(gap, gap === "small", "gap");
  deprecate("1.3.0", gap === "xlarge", '`gap="xlarge"`', '`gap="larger"`');
  gap = fallback(gap, gap === "xlarge", "larger");
  deprecate("1.3.0", gap === "default", '`gap="default"`', "omit the `gap` prop");
  gap = fallback(gap, gap === "default", true);
  deprecate("1.3.0", direction === "horizontal-reverse", '`direction="horizontal-reverse"`', "`horizontal` and `reverse` props");
  deprecate("1.3.0", direction === "vertical-reverse", '`direction="vertical-reverse"`', "reverse` prop");
  reverse = fallback(reverse, direction === "horizontal-reverse" || direction === "vertical-reverse", true);
  direction = fallback(direction ?? "vertical", isDefined(horizontal), horizontal ? "horizontal" : "vertical");
  direction = fallback(direction, direction === "horizontal-reverse", "horizontal");
  direction = fallback(direction, direction === "vertical-reverse", "vertical");
  const className = useClassNameFactory(componentClassName);
  const style = useMemo(() => ({
    ...{ flexBasis: basis },
    ...typeof grow !== "boolean" ? { flexGrow: grow } : {},
    ...typeof shrink !== "boolean" ? { flexShrink: shrink } : {},
    ...styleProp
  }), [basis, grow, shrink, styleProp]);
  return /* @__PURE__ */ jsx(Fragment, { children: children && /* @__PURE__ */ jsx(
    "div",
    {
      ...rest,
      "data-align": dataAttribute(align),
      "data-evenly": dataAttribute(evenly),
      "data-gap": dataAttribute(gap),
      "data-grow": dataAttribute(grow),
      "data-direction": dataAttribute(direction),
      "data-justify": dataAttribute(justify),
      "data-reverse": dataAttribute(reverse),
      "data-shrink": dataAttribute(shrink),
      "data-wrap": dataAttribute(wrap),
      className: className(null, classNameProp),
      style,
      ref,
      children
    }
  ) });
}));
Stack.displayName = "Stack";
export {
  Stack
};
//# sourceMappingURL=Stack.js.map
